import styled, { css } from "styled-components";

const CartContainer = styled.div`
    margin-bottom: 35px;
    position: realtive;

    .cart-loading {
        top: 0;
        left: 0;
        padding-top: 20px;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.5);
    }

    .cart-container-main {
        > .lt-sec-main {
            @media (min-width: 992px) {
                padding-right: 25px;
            }
        }
        > .rt-sec-main {
            @media (min-width: 992px) {
                padding-left: 25px;
                position: sticky;
                top: 10px;
            }
        }

        .img-sec {
            width: 60px;
            @media (min-width: 992px) {
                width: 100px;
            }
        }

        .list-main-inner {
            table {
                @media (max-width: 600px) {
                    width: 650px;
                }
                @media (max-width: 400px) {
                    width: 550px;
                }
            }
        }
    }

    .please-add {
        background: #efefef;
        text-align: center;
        padding: 12px 10px 11px;
        color: #666;
        font-size: 14px;
        border: 1px solid #333;
        margin-top: 15px;
    }

    .rt-sec-main {
        width: 100%;
        @media (min-width: 992px) {
            width: 350px;
        }
        > .inner {
            padding: 25px;
            border: 2px solid #333;
        }
        .header-part {
        }

        .promo-code {
            input,
            .btn {
                height: 36px;
                box-shadow: none !important;
            }
            input {
                &:focus {
                    border-color: #333;
                }
            }
            .btn {
                border: 2px solid #333;
                font-size: 13px;
                padding: 7px 12px;
                &:hover {
                    background-color: #333;
                    color: #fff;
                }
            }
        }

        .btns {
            margin-top: 30px;
        }
    }

    .default-btn {
        width: 100%;
        border: 2px solid #333;
        font-size: 13px;
        padding: 9px 12px;
        background-color: #333;
        color: #fff;
        height: 40px;
        &:hover {
            background-color: #000;
        }
    }

    .right-checkbout-bar-overlay {
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        opcity: 0;
        visibility: hidden;
        transition: 0.1s;
        &.active {
            z-index: 9;
            opcity: 1;
            visibility: visible;
        }
    }
    .right-checkbout-bar {
        position: fixed;
        right: -100%;
        width: 100%;
        height: 100%;
        z-index: 99;
        transition: 0.6s;
        @media (min-width: 500px) {
            width: 400px;
        }
        > .inner {
            padding: 5px 30px 30px;
            overflow: auto;
            height: 100%;
            background: #fff;
        }
        .close-icon {
            font-size: 25px;
            margin-bottom: 5px;
            text-align: right;
            a {
                color: #333;
            }
        }

        .frac {
            &:not(:last-child) {
                margin-bottom: 40px;
            }
        }

        input {
            box-shadow: none !important;
            border-color: #333;
            &:focus {
                border-color: #000;
            }
        }

        .form-item.has-error {
            > input {
                border-color: #dc3545;
            }
        }
    }

    .right-checkbout-bar-overlay {
        &.active {
            .right-checkbout-bar {
                right: 0;
            }
        }
    }

    .password-field {
        input {
            padding-right: 40px;
        }
        .icon {
            top: 34px;
            right: 12px;
            font-size: 17px;
        }
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type="number"] {
        -moz-appearance: textfield;
    }
`;
export default CartContainer;
